var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-col',{staticClass:"img-trooperz-hood",attrs:{"vs-justify":"center","vs-align":"center","vs-type":"flex","lg":"4","sm":"6","xs":"12"}},[_c('div',{staticClass:"hood-div-img"},[_c('img',{attrs:{"src":_vm.imgPath}})])])}
var staticRenderFns = []

export { render, staticRenderFns }